/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import MonthlyClosingEvent from '../../event/MonthlyClosingEvent'
import { MonthlyClosingHeadState } from '../state/MonthlyClosingHeadState'

class MonthlyClosingHeadsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case MonthlyClosingEvent.fetchAll:
        return List(payload.map(head => new MonthlyClosingHeadState(head)))

      case MonthlyClosingEvent.monthChanged:
        if (!payload.result) {
          return state
        }
        return List(payload.result.map(head => new MonthlyClosingHeadState(head)))

      default:
        return state
    }
  }
}

export default new MonthlyClosingHeadsStore()
